import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  confirmButtonStyle?: object;
  cancelButtonStyle?: object;
  children?: React.ReactNode;
}

export const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  isLoading = false,
  confirmButtonStyle = {},
  cancelButtonStyle = {},
  children
}: ConfirmModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
      sx={{ textAlign: 'center' }}
    >
      <DialogTitle id="confirm-modal-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-modal-description">
          {description}
        </DialogContentText>
        {children}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: '1rem' }}>
        <Button
          onClick={onClose}
          sx={cancelButtonStyle}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          sx={confirmButtonStyle}
          autoFocus
          disabled={isLoading}
        >
          {isLoading ? 'Aguarde...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
